import _slicedToArray from "/opt/build/repo/shueyshing-fe/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
/**
 * React hook to check when a valid media-query-string changes
 * (i.e. when the media query test starts or stops evaluating to true)
 *
 * @param {string} mediaQueryString valid media query string. E.g.: `(min-width: 425px)`
 * @returns {boolean} media-query matches value
 */

function useMediaQuery(mediaQueryString) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      queryMatch = _useState2[0],
      setQueryMatch = _useState2[1];

  useEffect(function () {
    var setMediaMatchHandler = function setMediaMatchHandler(e) {
      return setQueryMatch(e.matches);
    };

    var mediaQueryList = window.matchMedia(mediaQueryString);
    setMediaMatchHandler(mediaQueryList);
    mediaQueryList.addListener(setMediaMatchHandler);
    return function () {
      return mediaQueryList.removeListener(setMediaMatchHandler);
    };
  }, [mediaQueryString]);
  return queryMatch;
}

export default useMediaQuery;